import React from 'react';
import styled from 'styled-components';
import { boxStyles, BoxStylesProps } from './boxStyles';
import { media } from '../../lib/styles';

type Type = 'div' | 'section' | 'span';

interface Props extends BoxStylesProps {
    type?: Type;
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

const Component = styled.div(
    ({ paddingTop, paddingLeft, paddingBottom, paddingRight, textAlign }: BoxStylesProps) => {
        const styles = boxStyles({
            paddingTop,
            paddingLeft,
            paddingBottom,
            paddingRight,
            textAlign,
        });

        return `
            @media ${media('small')} {
                ${'small' in styles ? `${styles['small']}` : ''}
            }

            @media ${media('medium')} {
                ${'medium' in styles ? `${styles['medium']}` : ''}
            }

            @media ${media('normal')} {
                ${'normal' in styles ? `${styles['normal']}` : ''}
            }

            @media ${media('large')} {
                ${'large' in styles ? `${styles['large']}` : ''}
            }
        `;
    }
);

export default function Box({ children, type = 'div', ...rest }: Props) {
    return (
        <Component as={type} {...rest}>
            {children}
        </Component>
    );
}
